import { FC } from "react";
import { IconProps } from "./types";

export const XMarkThick: FC<IconProps & { dataAutomationId?: string }> = ({
  fill = "#000",
  width = 24,
  height = 24,
  className,
  dataAutomationId,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    data-automation-id={dataAutomationId}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 10.097 19.097 3 21 4.903 13.902 12 21 19.098 19.097 21 12 13.903 4.903 21 3 19.097 10.097 12 3 4.904 4.903 3 12 10.097z"
      fill={fill}
    />
  </svg>
);
